// A2: Work Management API service
import api from './api';
import type { Goal, Project, Task, EntityRef } from '../types/work';

export const workService = {
  // ── Goals ──────────────────────────────────────────────────────
  getGoals: async (params?: Record<string, any>): Promise<Goal[]> => {
    const r = await api.get('/goals', { params });
    return r.data;
  },
  getGoal: async (id: string): Promise<Goal> => {
    const r = await api.get(`/goals/${id}`);
    return r.data;
  },
  createGoal: async (data: Partial<Goal>): Promise<Goal> => {
    const r = await api.post('/goals', data);
    return r.data;
  },
  updateGoal: async (id: string, data: Partial<Goal>): Promise<Goal> => {
    const r = await api.put(`/goals/${id}`, data);
    return r.data;
  },
  deleteGoal: async (id: string): Promise<void> => {
    await api.delete(`/goals/${id}`);
  },

  // ── Projects ───────────────────────────────────────────────────
  getProjects: async (params?: Record<string, any>): Promise<Project[]> => {
    const r = await api.get('/projects', { params });
    return r.data;
  },
  getProject: async (id: string): Promise<Project> => {
    const r = await api.get(`/projects/${id}`);
    return r.data;
  },
  createProject: async (data: Partial<Project>): Promise<Project> => {
    const r = await api.post('/projects', data);
    return r.data;
  },
  updateProject: async (id: string, data: Partial<Project>): Promise<Project> => {
    const r = await api.put(`/projects/${id}`, data);
    return r.data;
  },
  deleteProject: async (id: string): Promise<void> => {
    await api.delete(`/projects/${id}`);
  },

  // ── Tasks ──────────────────────────────────────────────────────
  getTasks: async (params?: Record<string, any>): Promise<Task[]> => {
    const r = await api.get('/tasks', { params });
    return r.data;
  },
  getTask: async (id: string): Promise<Task> => {
    const r = await api.get(`/tasks/${id}`);
    return r.data;
  },
  createTask: async (data: Partial<Task>): Promise<Task> => {
    const r = await api.post('/tasks', data);
    return r.data;
  },
  updateTask: async (id: string, data: Partial<Task>): Promise<Task> => {
    const r = await api.put(`/tasks/${id}`, data);
    return r.data;
  },
  deleteTask: async (id: string): Promise<void> => {
    await api.delete(`/tasks/${id}`);
  },

  // ── Entity Refs ────────────────────────────────────────────────
  getEntityRefs: async (entityType: 'goals' | 'projects' | 'tasks', entityId: string): Promise<EntityRef[]> => {
    const r = await api.get(`/${entityType}/${entityId}/refs`);
    return r.data;
  },
  addEntityRef: async (entityType: 'goals' | 'projects' | 'tasks', entityId: string, ref: { entity_type: string; entity_id: string; label?: string }): Promise<EntityRef> => {
    const r = await api.post(`/${entityType}/${entityId}/refs`, ref);
    return r.data;
  },
  deleteEntityRef: async (entityType: 'goals' | 'projects' | 'tasks', entityId: string, refId: string): Promise<void> => {
    await api.delete(`/${entityType}/${entityId}/refs/${refId}`);
  },
};
